import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  console.log(theme);
  return {
    checkboxRadioDisabled: {
      color: `${theme.palette.secondary.main} !important`,
    },
    checkboxRadioLabelDisabled: {
      color: `${theme.palette.text.primary} !important`,
    },

    actionIcon: {
      cursor: 'pointer',
    },
  };
});
